(function () {
  var SECTION_SELECTOR = '.ctr-reviews-tabs';

  function getSwiper() {
    return window.Swiper || null;
  }

  function pauseAllVideos(section, exceptVideo) {
    var videos = document.querySelectorAll('video');
    videos.forEach(function (video) {
      if (exceptVideo && video === exceptVideo) return;
      if (!video.paused) video.pause();
      var card = video.closest('[data-ctr-rt-video-card]');
      if (card) {
        card.classList.remove('is-playing');
      }
    });
  }

  function setVideoPlaying(card, isPlaying) {
    if (!card) return;
    card.classList.toggle('is-playing', isPlaying);
    if (isPlaying) card.classList.add('is-started');
    var play = card.querySelector('[data-ctr-rt-play]');
    if (play) {
      play.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    }
  }

  function setVideoMuted(card, video, muted) {
    if (!card || !video) return;
    video.muted = muted;
    card.classList.toggle('is-muted', muted);
    var mute = card.querySelector('[data-ctr-rt-mute]');
    if (mute) {
      mute.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      mute.setAttribute('aria-pressed', muted ? 'true' : 'false');
    }
  }

  function destroySwiper(section) {
    if (section._ctrRtSwiper) {
      section._ctrRtSwiper.destroy(true, true);
      section._ctrRtSwiper = null;
    }
  }

  function cacheSlides(section) {
    if (section._ctrRtAllSlides) return;
    section._ctrRtAllSlides = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-rt-slide]')
    );
  }

  function getVisibleSlides(section) {
    cacheSlides(section);
    return Array.prototype.slice.call(
      section.querySelectorAll('.swiper-wrapper > [data-ctr-rt-slide]')
    );
  }

  function updateReadMore(section) {
    var wraps = section.querySelectorAll('[data-ctr-rt-text-wrap]');
    wraps.forEach(function (wrap) {
      var text = wrap.querySelector('[data-ctr-rt-text]');
      var button = wrap.querySelector('[data-ctr-rt-read-more]');
      if (!text || !button) return;

      wrap.classList.remove('is-expanded');
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');

      if (window.matchMedia('(min-width: 750px)').matches) return;

      if (text.scrollHeight > text.clientHeight + 2) {
        button.hidden = false;
      }
    });
  }

  function getSlideCategories(slide) {
    var raw = slide.getAttribute('data-ctr-rt-category') || '';
    return raw
      .split(',')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function slideMatchesCategory(slide, value) {
    if (value === 'all') return true;
    return getSlideCategories(slide).indexOf(value) !== -1;
  }

  function filterSlides(section, value) {
    var wrapper = section.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    cacheSlides(section);
    pauseAllVideos(section);
    destroySwiper(section);

    wrapper.innerHTML = '';
    section._ctrRtAllSlides.forEach(function (slide) {
      if (slideMatchesCategory(slide, value)) {
        wrapper.appendChild(slide);
      }
    });

    initSwiper(section);
    updateReadMore(section);
  }

  function initSwiper(section) {
    var SwiperLib = getSwiper();
    if (!SwiperLib) return;

    var el = section.querySelector('[data-ctr-rt-swiper]');
    if (!el) return;

    destroySwiper(section);

    var visible = getVisibleSlides(section);
    if (!visible.length) return;

    var paginationEl = section.querySelector('[data-ctr-rt-pagination]');
    var prevEl = section.querySelector('[data-ctr-rt-prev]');
    var nextEl = section.querySelector('[data-ctr-rt-next]');

    section._ctrRtSwiper = new SwiperLib(el, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      watchOverflow: true,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        750: {
          spaceBetween: 26,
        },
      },
      on: {
        slideChange: function () {
          pauseAllVideos(section);
        },
      },
    });
  }

  function setActiveTab(section, tab) {
    var tabs = section.querySelectorAll('[data-ctr-rt-tab]');
    tabs.forEach(function (item) {
      var isActive = item === tab;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var value = tab.getAttribute('data-ctr-rt-value') || 'all';
    filterSlides(section, value);
  }

  function initTabs(section) {
    var tabs = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-rt-tab]')
    );

    if (!tabs.length) {
      initSwiper(section);
      return;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveTab(section, tab);
      });
    });

    var active = section.querySelector('[data-ctr-rt-tab].is-active') || tabs[0];
    setActiveTab(section, active);
  }

  function initVideos(section) {
    cacheSlides(section);
    var cards = [];

    section._ctrRtAllSlides.forEach(function (slide) {
      var card = slide.querySelector('[data-ctr-rt-video-card]');
      if (card) cards.push(card);
    });

    cards.forEach(function (card) {
      if (card.dataset.ctrRtVideoReady === 'true') return;
      card.dataset.ctrRtVideoReady = 'true';

      var play = card.querySelector('[data-ctr-rt-play]');
      var mute = card.querySelector('[data-ctr-rt-mute]');
      var video = card.querySelector('[data-ctr-rt-video]');
      if (!play || !video) return;

      setVideoMuted(card, video, false);

      function togglePlayback(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (video.paused) {
          pauseAllVideos(section, video);
          setVideoPlaying(card, true);
          video.play().catch(function () {
            setVideoPlaying(card, false);
          });
          return;
        }

        video.pause();
        setVideoPlaying(card, false);
      }

      play.addEventListener('click', togglePlayback);
      video.addEventListener('click', togglePlayback);

      if (mute) {
        mute.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setVideoMuted(card, video, !video.muted);
        });
      }

      video.addEventListener('play', function () {
        pauseAllVideos(section, video);
        setVideoPlaying(card, true);
      });

      video.addEventListener('pause', function () {
        if (!video.ended) setVideoPlaying(card, false);
      });

      video.addEventListener('ended', function () {
        setVideoPlaying(card, false);
      });

      video.addEventListener('volumechange', function () {
        setVideoMuted(card, video, video.muted || video.volume === 0);
      });
    });
  }

  function initReadMore(section) {
    cacheSlides(section);

    section._ctrRtAllSlides.forEach(function (slide) {
      var buttons = slide.querySelectorAll('[data-ctr-rt-read-more]');
      buttons.forEach(function (button) {
        if (button.dataset.ctrRtReadMoreReady === 'true') return;
        button.dataset.ctrRtReadMoreReady = 'true';

        button.addEventListener('click', function () {
          var wrap = button.closest('[data-ctr-rt-text-wrap]');
          if (!wrap) return;
          wrap.classList.add('is-expanded');
          button.hidden = true;
          button.setAttribute('aria-expanded', 'true');
        });
      });
    });

    updateReadMore(section);
  }

  function initSection(section) {
    if (!section) return;

    if (section.dataset.ctrRtReady === 'true') {
      initSwiper(section);
      updateReadMore(section);
      return;
    }

    section.dataset.ctrRtReady = 'true';
    cacheSlides(section);
    initVideos(section);
    initReadMore(section);
    initTabs(section);

    var mq = window.matchMedia('(min-width: 750px)');
    var onChange = function () {
      initSwiper(section);
      updateReadMore(section);
    };

    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }

    section._ctrRtMqCleanup = function () {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', onChange);
      } else if (mq.removeListener) {
        mq.removeListener(onChange);
      }
    };
  }

  function findSection(root) {
    if (!root) return null;
    if (root.matches && root.matches(SECTION_SELECTOR)) return root;
    return root.querySelector ? root.querySelector(SECTION_SELECTOR) : null;
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function whenSwiperReady(cb) {
    if (getSwiper()) {
      cb();
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (getSwiper() || tries > 40) {
        clearInterval(timer);
        if (getSwiper()) cb();
      }
    }, 50);
  }

  whenSwiperReady(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrRtReady;
    section._ctrRtAllSlides = null;
    whenSwiperReady(function () {
      initSection(section);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    pauseAllVideos(section);
    if (section._ctrRtMqCleanup) {
      section._ctrRtMqCleanup();
      section._ctrRtMqCleanup = null;
    }
    destroySwiper(section);
    section._ctrRtAllSlides = null;
    delete section.dataset.ctrRtReady;
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var tab = target.closest('[data-ctr-rt-tab]');
    if (tab) {
      var tabSection = tab.closest(SECTION_SELECTOR);
      if (tabSection) setActiveTab(tabSection, tab);
      return;
    }

    var slide = target.closest('[data-ctr-rt-slide]');
    if (!slide) return;

    var section = slide.closest(SECTION_SELECTOR);
    if (!section) return;

    cacheSlides(section);

    var categories = getSlideCategories(slide);
    var inWrapper = slide.parentElement && slide.parentElement.classList.contains('swiper-wrapper');
    if (!inWrapper) {
      var matchingTab = null;
      for (var i = 0; i < categories.length; i++) {
        matchingTab = section.querySelector(
          '[data-ctr-rt-tab][data-ctr-rt-value="' + categories[i] + '"]'
        );
        if (matchingTab) break;
      }
      if (!matchingTab) {
        matchingTab = section.querySelector('[data-ctr-rt-tab][data-ctr-rt-value="all"]');
      }
      if (matchingTab) setActiveTab(section, matchingTab);
    }

    if (!section._ctrRtSwiper) return;

    var visible = getVisibleSlides(section);
    var index = visible.indexOf(slide);
    if (index < 0) return;

    section._ctrRtSwiper.slideTo(index);
  });
})();
